import AOS from "aos";

import { useEffect } from "react";
import { Link } from "react-router-dom";
import AboutArrowMain from "../../assets/images/about-arrow-main.png";
const SectionOne = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      {/* <!-- ====================================== About Section One ===================================== --> */}
      <section className="section-main overflow-hidden">
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6">
              <p className="main-text about-hello" data-aos="fade-down">
                {/* Hello, I am <span>👋</span> */}
              </p>
              <h1 className="JessicaBiogi" data-aos="fade-down">
                {/* Jessica Biogi */}
              </h1>

              <p className="Freelance about-freelance" data-aos="fade-down">
                <span>Marichi Tech AI</span> is a leading IT services company
                <span> based in the Nepal</span>, specializing in delivering
                innovative Web, Mobile, and Cloud solutions. We are committed to
                crafting seamless, user-centric digital experiences that drive
                business growth and technological excellence.
              </p>

              <div className="about-main-buttons">
                <p
                  className="explore-me about-contact-btn"
                  data-aos="fade-right"
                >
                  <Link to="/contact">
                    CONTACT US
                    <svg
                      className="expo-arrow"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <g>
                        <path
                          d="M6.66669 16H25.3334"
                          stroke="#FFF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M20 21.3333L25.3333 16"
                          stroke="#FFF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M20 10.6666L25.3333 16"
                          stroke="#FFF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </svg>
                  </Link>
                </p>
              </div>
            </div>
            <div
              className="col-xxl-6 col-xl-6 col-lg-6 about-main-img-sec"
              id="main"
            >
              <img
                className="about-flower-img"
                src={`https://images.pexels.com/photos/3184298/pexels-photo-3184298.jpeg`}
                alt="flower"
              />
              <img
                className="about-img-main"
                src={`https://images.pexels.com/photos/3184298/pexels-photo-3184298.jpeg`}
                alt="about-img-main"
                data-aos="fade-left"
              />
              <img
                className="about-arrow-main"
                id="arrow"
                src={AboutArrowMain}
                alt="about-arrow-main"
              />
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ====================================== About Section One End===================================== --></div> */}
    </>
  );
};
export default SectionOne;
